import Vue from 'vue'
import App from './App.vue'

import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

// Wizard
import VueGoodWizard from 'vue-good-wizard';

Vue.use(BootstrapVue)
Vue.use(VueGoodWizard)

// Vue.component('todo-item', {
//   props: ['todo'],
//   template: '<li>This is a todo</li>'
// })


// GLOBALS
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js